document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-home-slider]').forEach(function (slider) {
    var slides = Array.from(slider.querySelectorAll('[data-home-slide]'));
    var dots = Array.from(slider.querySelectorAll('[data-slider-dot]'));
    var current = 0;
    var timer;
    var autoplay = slider.dataset.autoplay === 'true';
    var speed = Math.max(3000, Number(slider.dataset.speed) || 5000);
    if (slides.length < 2) return;

    function showSlide(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    function stop() { if (timer) window.clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(function () { showSlide(current + 1); }, speed);
    }

    var previous = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (previous) previous.addEventListener('click', function () { showSlide(current - 1); start(); });
    if (next) next.addEventListener('click', function () { showSlide(current + 1); start(); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { showSlide(Number(dot.dataset.sliderDot)); start(); }); });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    document.addEventListener('shopify:block:select', function (event) {
      if (slider.contains(event.target)) { showSlide(Number(event.target.dataset.slideIndex || 0)); stop(); }
    });
    start();
  });
});
